function Pagination({page, totalPages, onChangePage}) {
  return (
    <nav>
      <ul className="pagination justify-content-center mt-3">
        <li className={`page-item ${(page === 1 || totalPages === 0) ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => onChangePage(page - 1)} disabled={page === 1 || totalPages === 0}>
            Anterior
          </button>
        </li>
        <li className="page-item disabled">
          <span className="page-link">
            Página {totalPages > 0 ? page : 0} de {totalPages}
          </span>
        </li>
        <li className={`page-item ${(page === totalPages || totalPages === 0) ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => onChangePage(page + 1)} disabled={page === totalPages || totalPages === 0}>
            Siguiente
          </button>
        </li>
      </ul>
    </nav>
  )
  }

export default Pagination;
